import axios from '@src/utils/axios'

const module = 'application'
const axiosInstance = axios(false);

export default {
  'pagination': (ctx, data) => axiosInstance.get(`/${module}/paginate`, {params:data}),
  'allStatus' : (ctx, data) => axiosInstance.get(`/${module}/all_status`, data),
  'getApplication': (ctx, data) => axiosInstance.get(`/${module}`, {params:data}),
  'approve' : (ctx, data) => axiosInstance.post(`/${module}/approve`, data),
  'resendConsent' : (ctx, data) => axiosInstance.post(`/${module}/resend_consent`, data),
  'createNote': (ctx, data) => axiosInstance.post(`/${module}/create_note`, data),
  'update' : (ctx, data) => axiosInstance.put(`/${module}/${data.id}`, data), 
  'getInterviewDetails': (ctx, data) => axiosInstance.get(`/${module}/interview_details`, {params:data}),
}